import {
  AIR_MAINTENANCE_MODE_FLAG,
  AIR_PRE_OUTAGE_BANNER_FLAG,
  MAINTENANCE_MODES,
  NAVIGATION_PATHS,
  MAINTENANCE_SUPPORT_PHONE_LD_FLAG,
} from './constants';

export const MAINTENANCE_DEFAULT_FLAGS = [
  { name: AIR_PRE_OUTAGE_BANNER_FLAG, default: false },
  { name: AIR_MAINTENANCE_MODE_FLAG, default: MAINTENANCE_MODES.OFF },
  { name: MAINTENANCE_SUPPORT_PHONE_LD_FLAG, default: '' },
];

export const PHONE_PLACEHOLDER = '{phone}';

export const resolveSupportPhone = (value) =>
  typeof value === 'string' && value.trim() ? value.trim() : '';

export const fillPhonePlaceholder = (text, phone) =>
  phone
    ? String(text ?? '')
        .split(PHONE_PLACEHOLDER)
        .join(phone)
    : text;

export const resolveMaintenanceMode = (value) =>
  value === MAINTENANCE_MODES.PLANNED_MIGRATION || value === MAINTENANCE_MODES.UNPLANNED_P1
    ? value
    : MAINTENANCE_MODES.OFF;

const MAINTENANCE_EXEMPT_PATHS = [
  NAVIGATION_PATHS.confirmation,
  NAVIGATION_PATHS.cancelConfirmation,
];

const trimSlashes = (value) => value.replace(/^\/+|\/+$/g, '');

export const isMaintenanceExemptPath = (pathname = '') => {
  const segments = trimSlashes(pathname).split('/');
  return MAINTENANCE_EXEMPT_PATHS.some((path) => segments.includes(trimSlashes(path)));
};
